(() => {
  if (customElements.get('hy-footer-logo')) return;
  let runtime;
  class FooterLogo extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.viewer = this.querySelector('[data-main]');
      this.wordViewer = this.querySelector('[data-word]');
      this.word = this.querySelector('[data-word-drag]');
      this.arena = this.querySelector('.footer-logo-3d__arena');
      this.status = this.querySelector('[data-logo-status]');
      this.reset = this.querySelector('[data-logo-reset]');
      this.retry = this.querySelector('[data-logo-retry]');
      this.desktop = matchMedia('(min-width:750px)');
      for (const viewer of [this.viewer,this.wordViewer]) {
        viewer.addEventListener('load', () => this.loaded(), options);
        viewer.addEventListener('error', () => this.failed(), options);
      }
      this.desktop.addEventListener('change', () => {
        this.endDrag(); this.positionWord(0,300);
        if (this.started) this.load();
      }, options);
      this.reset.addEventListener('click', () => {
        this.viewer.resetTurntableRotation(0);
        this.viewer.cameraOrbit = '0deg 90deg 105%';
        this.positionWord(0,300);
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) this.viewer.jumpCameraToGoal();
      }, options);
      this.retry.addEventListener('click', () => this.load(), options);
      this.word.addEventListener('pointerdown', event => {
        if (!this.desktop.matches || !event.isPrimary || event.button !== 0) return;
        event.preventDefault();
        this.drag={id:event.pointerId,startX:event.clientX,startY:event.clientY,x:this.x||0,y:this.y??300};
        this.word.setPointerCapture(event.pointerId); this.word.classList.add('is-dragging');
      }, options);
      this.word.addEventListener('pointermove', event => {
        if (this.drag?.id !== event.pointerId) return;
        this.positionWord(this.drag.x+event.clientX-this.drag.startX,this.drag.y+event.clientY-this.drag.startY);
      }, options);
      for (const name of ['pointerup','pointercancel','lostpointercapture']) this.word.addEventListener(name, () => this.endDrag(), options);
      this.word.addEventListener('keydown', event => {
        if (!this.desktop.matches) return;
        const step=event.shiftKey?30:10;
        const moves={ArrowLeft:[-step,0],ArrowRight:[step,0],ArrowUp:[0,-step],ArrowDown:[0,step]};
        if (event.key==='Home') {event.preventDefault();this.positionWord(0,300);}
        else if (moves[event.key]) {
          event.preventDefault(); const [dx,dy]=moves[event.key]; this.positionWord((this.x||0)+dx,(this.y??300)+dy);
        }
      }, options);
      this.resizeObserver=new ResizeObserver(() => this.positionWord(this.x||0,this.y??300));
      this.resizeObserver.observe(this.arena);
      this.observer=new IntersectionObserver(entries => {
        if (entries.some(entry=>entry.isIntersecting)) {this.observer.disconnect();this.started=true;this.load();}
      },{rootMargin:'180px'});
      this.observer.observe(this);
    }
    positionWord(x,y) {
      if (!this.desktop.matches) return;
      this.x=Math.max(0,Math.min(x,this.arena.clientWidth-this.word.offsetWidth));
      this.y=Math.max(0,Math.min(y,this.arena.clientHeight-this.word.offsetHeight));
      this.word.style.transform=`translate(${this.x}px,${this.y}px)`;
    }
    endDrag() {
      const id=this.drag?.id; this.drag=null;
      if (id!==undefined && this.word.hasPointerCapture(id)) this.word.releasePointerCapture(id);
      this.word.classList.remove('is-dragging');
    }
    async load() {
      const signal=this.abort.signal;
      clearTimeout(this.timer);
      this.classList.remove('is-ready'); this.reset.hidden=true; this.retry.hidden=true;
      this.status.textContent='Loading 3D…';
      this.timer=setTimeout(()=>this.failed(),20000);
      try {
        if (!customElements.get('model-viewer')) {
          runtime ||= import(this.dataset.runtime).catch(error=>{runtime=null;throw error;});
          await runtime;
        }
        if (signal.aborted) return;
        const src=this.desktop.matches?this.viewer.dataset.symbol:this.viewer.dataset.full;
        if (this.viewer.src!==src) this.viewer.src=src;
        if (this.desktop.matches) this.wordViewer.src=this.wordViewer.dataset.src;
        this.loaded();
      } catch {if (!signal.aborted) this.failed();}
    }
    loaded() {
      const expected=this.desktop.matches?this.viewer.dataset.symbol:this.viewer.dataset.full;
      if (this.viewer.src!==expected || !this.viewer.loaded || (this.desktop.matches&&!this.wordViewer.loaded)) return;
      clearTimeout(this.timer);this.classList.add('is-ready');
      this.status.textContent=this.desktop.matches?'Drag H to rotate · Drag lettering to move':'Drag to rotate';
      this.reset.hidden=false;this.retry.hidden=true;
    }
    failed() {
      clearTimeout(this.timer);this.classList.remove('is-ready');
      this.status.textContent='3D unavailable';this.reset.hidden=true;this.retry.hidden=false;
    }
    disconnectedCallback() {
      clearTimeout(this.timer);this.endDrag();this.abort?.abort();this.observer?.disconnect();this.resizeObserver?.disconnect();this.abort=null;
    }
  }
  customElements.define('hy-footer-logo',FooterLogo);
})();
